export default "__VITE_ASSET__daf78c59__"